module.exports = __webpack_public_path__ + "static/media/menu-payments.ebc8d4df.svg";